import { TweenEngineGreenSockInstance } from '../types';
import { TweenEngineGreenSock } from './TweenEngineGreenSock3';

/**
 * Constructor for a local tween engine.
 */
export class TweenEngine {
  constructor(gsap: GSAP, plugins: GSAPPlugin[]) {
    this.engine = new TweenEngineGreenSock(gsap, plugins);
  }
  engine: TweenEngineGreenSockInstance;
}
